import { useMutation } from "@tanstack/react-query";
import { axiosApi } from "./axios";
import type { AddressValidationResponse, ValidateAddressDto } from "@/types/api/api-types";

export const validateFedexAddress = async (dto: ValidateAddressDto) => {
  const response = await axiosApi.post<AddressValidationResponse>(
    "/fedex/bo/address-validation",
    dto,
  );
  return response.data;
};

export const useValidateFedexAddress = () => {
  return useMutation({
    mutationFn: validateFedexAddress,
  });
};
